var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as Yup from 'yup';
import { callingModes } from '../types/campaignTypes';
// const phoneRegExp = /^\+(?:[0-9] ?){6,14}[0-9]$/;
// eslint-disable-next-line import/prefer-default-export
export var campaignFormValidationSchema = function (dialerDefaults) {
    return Yup.object().shape({
        campaignConfigName: Yup.string()
            .min(3, 'Minimum length of 3')
            .max(200, 'Maximum length of 200')
            .required('Required'),
        callingMode: Yup.string().required('Required').is(__spreadArrays(callingModes)),
        group: Yup.string()
            .matches(/^(?!(none)$)/, 'Required')
            .required('Required'),
        queue: Yup.string().when('callingMode', {
            is: function (callingMode) { return callingMode !== 'agentless'; },
            then: Yup.string()
                .matches(/^(?!(none)$)/, 'Required')
                .required('Required')
        }),
        contactList: Yup.string()
            .matches(/^(?!(none)$)/, 'Required')
            .required('Required'),
        defaultCallerID: Yup.string()
            .matches(/^(?!(none)$)/, 'Required')
            .required('Required'),
        activePhoneFields: Yup.array()
            .min(1, 'Must have at least 1 active items')
            .required('Required'),
        weight: Yup.number()
            .min(1, 'Minimum Priority is 1')
            .max(100, 'Maximum Priority is 100')
            .required('Required'),
        initialCallsPerAgent: Yup.number().when('callingMode', {
            is: function (callingMode) { return callingMode !== 'agentless'; },
            then: Yup.number()
                .min(dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.InitialCpaMin, "Minimum CPA is " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.InitialCpaMin))
                .max(dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.InitialCpaMax, "Maximum CPA is " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.InitialCpaMax))
                .required('Required')
        }),
        maxPerAgent: Yup.number().when('callingMode', {
            is: function (callingMode) { return callingMode !== 'agentless'; },
            then: Yup.number()
                .min(dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.InitialCpaMin, "Minimum CPA is " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.InitialCpaMin))
                .max(dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.MaxCPA, "Maximum CPA is " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.MaxCPA))
                .required('Required')
        }),
        initialCpaMode: Yup.string().when('callingMode', {
            is: function (callingMode) { return callingMode !== 'agentless'; },
            then: Yup.string()
                .matches(/^(?!(none)$)/, 'Required')
                .required('Required')
        }),
        initialPacing: Yup.number().when('callingMode', {
            is: function (callingMode) { return callingMode !== 'agentless'; },
            then: Yup.number()
                .required('Required')
                .when('initialCpaMode', {
                is: 'samples',
                then: Yup.number()
                    .min(dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.InitialPacingSamplesMin, "Inital Pacing Samples Minimum is " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.InitialPacingSamplesMin))
                    .max(dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.InitialPacingSamplesMax, "Inital Pacing Samples Maximum is " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.InitialPacingSamplesMax))
                    .required('Required')
            })
                .when('initialCpaMode', {
                is: 'duration',
                then: Yup.number()
                    .required('Required')
                    .min(dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.InitialPacingDurationMin, "Inital Pacing Duration Minimum is " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.InitialPacingDurationMin))
                    .max(dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.InitialPacingDurationMax, "Inital Pacing Duration Maximum is " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.InitialPacingDurationMax))
            })
        }),
        aBAIncrement: Yup.number().when('callingMode', {
            is: function (callingMode) { return callingMode !== 'agentless'; },
            then: Yup.number()
                .min(dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.AbandonmentIncrementMin, "Minimum Increment is " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.AbandonmentIncrementMin))
                .max(dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.AbandonmentIncrementMax, "Maximum Increment is " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.AbandonmentIncrementMax))
                .required('Required')
        }),
        cPAModifier: Yup.number().when('callingMode', {
            is: function (callingMode) { return callingMode !== 'agentless'; },
            then: Yup.number()
                .min(dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.CpaModifierMin, "Minimum Modifier is " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.CpaModifierMin))
                .max(dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.CpaModifierMax, "Maximum Modifier is " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.CpaModifierMax))
                .required('Required')
        }),
        aBACalculation: Yup.string().when('callingMode', {
            is: function (callingMode) { return callingMode !== 'agentless'; },
            then: Yup.string()
                .matches(/^(?!(none)$)/, 'Required')
                .required('Required')
        }),
        aBATargetRate: Yup.number().when('callingMode', {
            is: function (callingMode) { return callingMode !== 'agentless'; },
            then: Yup.number()
                .min(dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.AbaTargetRateMin, "Minimum ABA Target Rate is " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.AbaTargetRateMin))
                .max(dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.AbaTargetRateMax, "Maximum ABA Target Rate is " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.AbaTargetRateMax))
                .required('Required')
        }),
        concurrentCalls: Yup.number().when('callingMode', {
            is: function (callingMode) { return callingMode !== 'power'; },
            then: Yup.number()
                .min(dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.ConcurrentCallsMin, " Minimum Concurrent Calls is " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.ConcurrentCallsMin))
                .max(dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.ConcurrentCallsMax, "Maximum Concurrent Calls is " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.ConcurrentCallsMax))
                .required('Required')
        }),
        customAttributes: Yup.array().optional()
    });
};
//# sourceMappingURL=CampaignValidation.js.map